
var map;


var markerClusters = [];


var allContainers = [];

var homeMarker;
var initialZoomLevel = 12;
var resizeTimer;

var enabledContainerTypes = [];

var $filterForm;
var $addressForm;

var activeInfoWindow;
            
$(document).ready(function(){    
    if(googleMapsLoaded) {
        afterInit();
    }
    else {
        $(window).on('googleMapsLoaded', function(){
            afterInit();
        });
    }
});


function afterInit(){  
    
    console.log(locations);
        
    $filterForm = $("#filters");
    $addressForm = $("#addressForm");
    
    initContainersGoogleMap($("#map"), function(e){            
        if($("#form_postcode").val()!=='' && $("#form_huisnummer").val() !==''){
            $("#addressForm").trigger('submit');
        }
        else {
            showLoader(false);
        }
    });
    
    $("input.toggleMarkerType").change(function(ev){
        //toggleMarkerType(this.value, this.checked);
        var enabledFilters = $filterForm.serializeForm().filters;
        if(typeof enabledFilters === 'string') enabledFilters = [enabledFilters];        
        enabledContainerTypes = enabledFilters;
        
        setMarkersVisibility();
    });
           
    $addressForm.validate({
        errorPlacement: function(error, element) {}
    });
    
    $addressForm.submit(function(e){
        e.preventDefault();        
        if($(this).valid()) {
            var addressData = $(this).serializeForm();
            loadUserAddressAndPrivateContainer(addressData);
        }
    });
    
    $("#controlsHandle").click(function(){
        $("#controls").toggleClass('closed');        
    });
    
    $("#chooseOtherAddress").click(function() {        
       $("#foundAddressContainer").addClass('d-none').removeClass('d-flex');
       $("#addressForm").removeClass('d-none');  
       clearCookie('dar_address');       
    });
    
    $("#mobileFilterOpen").click(function(){
        $("#filters").addClass('show');
    });
    $("#mobileFilterClose").click(function(){
        $("#filters").removeClass('show');
    });
    
    
}


function initContainersGoogleMap(elem, callback) {
    
    
    var _elem = elem.get(0);
        
    
    var initialMapCenter = locations[currentLocation].geo;
    
    map = new google.maps.Map(_elem, {
        zoom: (window.innerWidth >= 768) ? 13:12,
        center: initialMapCenter, 
        mapTypeControl: false,
        fullscreenControl: false,
        streetViewControl: false,        
        zoomControl: (window.innerWidth >= 768),
        zoomControlOptions: {
            position: google.maps.ControlPosition.RIGHT_CENTER
        },
        gestureHandling: 'greedy',
        styles: mapStyle
    });
        
    containerTypes.forEach(function(type){
        
        enabledContainerTypes.push(type);
                
        var clusterStyle = {    
            url: theme_url+'/assets/dist/img/dar/afvalsoorten-marker/'+ type +'.svg',
            height: 40, 
            width: 40,
            backgroundPosition: "center center",
            anchorIcon: [40, 20],
            spanStyle: "border: 1px solid #000; " +
            "background: white; color: black;" +
            "text-align: center; line-height: 16px; border-radius: 100%; font-size: 12px; font-weight: 400; " +
            "font-family: Roboto,sans-serif; box-sizing: border-box;" +
            "display: block; width: 16px; height: 16px;" +
            "position: absolute; top:28px; left:16px"
        };
        
        markerClusters[type] = new MarkerClusterer(map, [] ,{ 
            enableRetinaIcons: true, 
            maxZoom: 14, 
            zoomOnClick:true, 
            ignoreHidden: true, 
            imageSizes: [40],
            averageCenter: true,
            styles:[clusterStyle]  });
        
    });
        
    ajax('get-containers', null, function(containers){        
        containers.forEach(function(container){
            addContainerMarker(container);         
        });
                
        setFiltersVisibility();
        if(typeof callback === 'function'){
            callback();
        }
    });
    
};


function addContainerMarker(container){
    
    var infoIconUrl =  theme_url + '/assets/dist/img/dar/afvalsoorten/' + container.type + '.svg';
    
    var infoContent = '<div class="d-flex align-items-center infoWindow">' +
        '<div class="mr-3">' +
        '<img class="icon" src="'+infoIconUrl+'" alt="'+container.name+'" />' +
        '</div>' +
            '<div>' +
                '<strong>'+container.name+'</strong><br/>' +
                container.adres+ '<br/>'+container.plaats +
        ((container.locked) ? '<br/><em class="locked">' +
            '<img src="'+theme_url+'/assets/dist/img/dar/lock.svg" alt="Afgesloten">'+privateContainersTxt+'</em>':'') +
        ((container.type=='milieustraat' && milieuStratenPagePath) ? '<br/><a href="'+milieuStratenPagePath+'">Openingstijden &amp; meer informatie &rsaquo;</a>': '') 
            '</div>' +
        '</div>';
    
    var icon;
    
        
    icon = {
        url: null,
        size: new google.maps.Size(40, 40),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(20, 40),
        scaledSize: new google.maps.Size(40, 40)
    };
        
    if(container.locked) {
        icon.url = theme_url + '/assets/dist/img/dar/afvalsoorten-marker/' + container.type + '-lock.svg';  
    }
    else {
        icon.url = theme_url + '/assets/dist/img/dar/afvalsoorten-marker/' + container.type + '.svg';
    }
    
    var markerIsVisible = determineContainerVisibility(container);
    
    var marker = addMapMarker({ lat: container.lat, lng: container.lng }, icon, markerIsVisible, infoContent);
    
    container.marker = marker;
    markerClusters[container.type].addMarker(marker);
        
    allContainers.push(container);
    
    return marker;
    
}

function determineContainerVisibility(container){
    return (
        (currentLocation==='other' || container.locations.includes(currentLocation))
        &&
        enabledContainerTypes.includes(container.type)    
    );
}

function setMarkersVisibility(){
    allContainers.forEach(function(container){        
        var containerVisible = determineContainerVisibility(container);
        
        container.marker.setVisible(containerVisible);
        if(!containerVisible && container.marker.infoWindow){
            container.marker.infoWindow.close();
        }        
    });
    
    for(var type in markerClusters) {
        var markerCluster = markerClusters[type];
        markerCluster.repaint();    
    }
}

function addMapMarker(position, icon, visible, infoContent) {
         
    var marker = new google.maps.Marker({
        position: position,
        map: map,
        // animation: google.maps.Animation.DROP,
        icon: icon,
        visible: visible
    }); 
        
    if(infoContent){
        marker.infoWindow = new google.maps.InfoWindow({
            content: infoContent
        });
        
        marker.addListener('click', function (e) {
            if(activeInfoWindow) activeInfoWindow.close();
            activeInfoWindow = marker.infoWindow;
            activeInfoWindow.open(map, marker);
        });
    }
    
    return marker;    
}

function removeContainer(container){
    console.log('Removing '+container.type+ ' @ '+container.adres+ ' '+container.plaats);
    markerClusters[container.type].removeMarker(container.marker);
    container.marker.setMap(null);    
    allContainers.splice(allContainers.indexOf(container),1);
}



function setFiltersVisibility(){
    
    for(var type in markerClusters){
        var markerCluster = markerClusters[type];
        
        var numMarkers = markerCluster.getTotalMarkers();
        var $markerFilter = $(".marker-filter[data-type=\""+type+"\"]");
        
        var filterEnabled = (numMarkers !== 0);
        
        $markerFilter.toggleClass('d-none', !filterEnabled);//tmp
        $markerFilter.find('input').prop('disabled', !filterEnabled)        
       
    }
    
    var hasVisibleLockedContainers = allContainers.some(function(container){
        return (container.locked && container.marker.getVisible());
    });
        
    if(hasVisibleLockedContainers){
        $("#lock-explanation").removeClass('d-none').addClass('d-flex');
    }
    else {
        $("#lock-explanation").removeClass('d-flex').addClass('d-none');
    }
    
    $("#filters").removeClass('d-none');    
}

function resetUserAddressAndPrivateContainer(){
        
    $("#foundAddressTxt").text('');    
    $("#foundAddressContainer").removeClass('d-flex').addClass('d-none');
   
    //Remove private containers
    allContainers.filter(function(container){
        return container.private;
    }).forEach(removeContainer);
    
    if(homeMarker) {
        homeMarker.setMap(null);
        homeMarker = null;
    }  
}


function beforeSetLocationReload() {    
    clearCookie('dar_address');  
}

function updateLocation(locationKey, hard){
    $(".currentLocationName").text(locations[locationKey].name);
    if(hard) {
        $("#gemeentes").find('.setLocation.selected').removeClass('selected');
        $("#gemeentes").find('.setLocation[data-location=' + locationKey + "]").addClass('selected');
    }
    currentLocation = locationKey;
    
}

function loadUserAddressAndPrivateContainer(addressData){
    showLoader();    
    
     
    
    ajax('find-address-geolocation-and-containers', addressData, function(response){
        
        console.log(response.adres);
        
        resetUserAddressAndPrivateContainer();     
        
        if(response.adres) {
            var addressJson = JSON.stringify({ postcode: response.adres.postcode, huisnummer: response.adres.huisnummer, huisnummer_toevoeging: response.adres.huisnummerToevoeging });
            setCookie('dar_address', addressJson, 30);
            
            var fullAddress = '<span>'+response.adres.straat+ ' '+response.adres.huisnummer + '';
            if(response.adres.huisnummerToevoeging !== null) fullAddress += response.adres.huisnummerToevoeging;
            fullAddress += ',</span><span class="nowrap">'+response.adres.postcode+ ',</span><span class="nowrap">'+response.adres.plaats+'</span>';

            
            $("#foundAddressTxt").html(fullAddress);
            $("#foundAddressContainer").removeClass('d-none').addClass('d-flex');
            $("#addressForm").addClass('d-none');
            
            
            if(currentLocation !== response.adres.gemeenteKey){
                updateLocation(response.adres.gemeenteKey, true);                
                setMarkersVisibility();
            }           
        }
        if(response.geo){
            map.setCenter(response.geo);
            map.setZoom(15);  
            
            var homeIcon = {
                url: theme_url + '/assets/dist/img/dar/afvalsoorten-marker/home.svg',
                size: new google.maps.Size(34, 40),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(17, 40),
                scaledSize: new google.maps.Size(34, 40)
            };
            homeMarker = addMapMarker(response.geo, homeIcon, true);
        }
        if(response.containers){
            response.containers.forEach(function(container){
                addContainerMarker(container);
            })
        }
        
        if(window.innerWidth < 768){
            $("#controls").addClass('closed');        
        }
        
        setFiltersVisibility();
        showLoader(false);
        
    }, function(err){
        
        showLoader(false);
        
        console.error(err);    
        var errorMessage = 'Er is iets misgegaan. Controleer je invoer en probeer het opnieuw.';
        
        if(err && err.message){
            if(err.message === 'address-not_found') {
                errorMessage = 'Uw adres kon niet worden gevonden. Controleer uw invoer en probeer het opnieuw.';
            }
        }
        
        alertModal(errorMessage);
    });
    
}


$(window).resize(function(){
   if(map){
       if(resizeTimer){
           clearTimeout(resizeTimer);
       }       
       resizeTimer = setTimeout(function(){
           map.setOptions({
               zoomControl: (window.innerWidth >= 768)
           });           
       },50);
   } 
});

function showLoader(show){
    if(typeof show === 'undefined') show = true;    
    $("#main").toggleClass('show_loader', show);
}

var mapStyle = [
    
  {
    "featureType": "administrative.land_parcel",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "administrative.neighborhood",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "poi",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  }, 
  {
    "featureType": "road",
    "elementType": "labels",
    "stylers": [
      {
        "visibility": "on"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "labels.text",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  }
];